export default {
  nav: {
    isFetching: false,
    reportList: [],
    error: null,
  },
  auth: {
    isFetching: false,
    accessToken: null,
    tokenExpiry: 0,
    otherTabActive: false,
    otherTabLogout: false,
  },
  accountsProfile: {
    profile: {},
  },
  currentCaseStageImages: {
    images: [],
    isFetching: false,
    lastUpdated: null,
    error: null,
  },
  notification: {
    show: false,
    banner: {},
    error: null,
  },
  accountNumber: {
    lockedId: -1,
    locked: true,
  },
  searchFilters: {
    searchTypeId: -1,
    filters: [],
  },
  filterElements: {
    data: [],
  },
  savedFilters: {
    filters: [],
  },
  drawer: {
    isDrawerActive: false,
  },
  appSearch: {
    isSearchActive: false,
    columns: [],
    pageId: '',
    isActiveStageIndicatorSettingsEnabled: false,
  },
  transactionSearch: {
    addCurrentCaseNumber: 0,
  },
  recentCases: [],
  imageReader: {
    images: [],
    isFetching: false,
    lastUpdated: null,
    error: null,
  },
  imageEditorData: {
    pageContent: '',
    pageId: -1,
    selectedImages: [],
    documentId: '',
    isFetching: false,
    status: {},
  },
  nestedFieldSelectorData: {
    fieldCount: 0,
    list: [],
    softDeleted: [],
    inputList: [],
  },
  dataColumns: {
    columns: [],
    pageId: '',
  },
  floatingPanelCords: {
    display: false,
    pageX: 0,
    pageY: 0,
  },
  timelineFilters: {
    sectionFilters: [],
    activeSectionFilter: [],
  },
  organization: {
    cachedLoginUserOrgs: {
      TOP_LEVEL: [],
    },
    cachedMerchantCounts: {},
    isFetching: false,
    countIsFetching: false,
    error: null,
  },
  globalFilter: {
    selectedMerchants: '',
    filters: [],
    orgIds: [],
    supportOrgIds: [],
    scheduleSelectedMerchants: 0,
    scheduleFilters: [],
    scheduleOrgIds: [],
    scheduleSupportOrgIds: [],
    lowestLevelSelected: '',
    scheduleMerchantList: [],
  },
  toggleAppSearchPanel: {
    isRelatedTransactionGridOpen: false,
    isRelatedTransactionGridLoaded: false,
  },
  merchantDetails: {
    merchantDetails: {},
  },
  imageSelection: {
    isArchiving: false,
    archiveResponse: {},
    error: null,
  },
  amexDisputeReasonCode: {},
  unResolvedBannerStatus: false,
  caseInfo: {
    openCases: [],
    disputeStages: {
      amexDisputeStages: [],
    },
  },
  activeCases: [],
  caseDocuments: {
    documentNames: [],
    documentSize: [],
    documentTypeNames: [],
    docReceivedDates: [],
    disputeStageNames: [],
    imageToolKitData: [],
    pageCount: [],
    pageListArray: [],
    issuerImageData: {
      selectedPages: {},
      addClass: {},
      imageOrderSeq: {},
      pageCount: {},
      selectAllFlag: {},
      orderOfSelectedPages: [],
    },
    merchantImageData: {
      selectedPages: {},
      addClass: {},
      imageOrderSeq: {},
      pageCount: {},
      selectAllFlag: {},
      orderOfSelectedPages: [],
    },
  },
};
